<template>
    <div>
      <product-resume class="product-resume"/>
      <subtittle-section class="subtitle-section" :content="this.$route.meta.navigation.subtitle()"/>
      <div class="section-container">
        <div class="main-section">
          <form-skier v-for="(participant, i) in details"
            :ref="`participant${i}`"
            :key="i"
            :participant="participant"
            :index="i" />
          <form-contact
            ref="contact"
            :save-contact-data="saveContactData"
            :is-logged="isLogged" />
          <separator class="mb-1 lg:mb-0"/>
          <continue :price="totalPrice" :button-text="$t('when.continue')" :button-action="validateAndContinue" :active="true"/>
        </div>
      </div>
    </div>
</template>

<script>

import ProductResume from "./components/product-resume";
import SubtittleSection from "@/components/common/subtittle-section";
import Separator from "@/components/common/separator";
import FormSkier from "@/components/form/form-skier";
import FormContact from "@/components/form/form-contact";
import Continue from "@/components/common/continue";
import { mapGetters, mapActions } from 'vuex';
import {keepScroll} from "../../mixins";

export default {
  name: "Participants",
  metaInfo() {
      return { 
          title: `${this.$t('participants.meta.title')} - ${this.resort.name}`,
          meta: [
              { name: 'description', content:  this.$t('participants.meta.description')}, 
          ]
      }
  },
  mixins: [keepScroll],
  components: {
    Continue,
    FormContact,
    FormSkier,
    Separator,
    ProductResume,
    SubtittleSection,
  },
  computed: {
    ...mapGetters('order', ['details', 'totalPrice']),
    ...mapGetters('resort', ['resort', 'selectedProduct', 'selectedCatalog']),
    details() {
      return this.$store.getters['order/details']
    },
    user() {
      return this.$store.getters['auth/user']
    },
    isLogged() {
      return this.$store.getters['auth/isUserLoggedIn']
    },
    validForm() {
      return this.forms.every(form => form.isValid)
    }
  },
  methods: {
    ...mapActions('prices', ['loadExtrasPrices']),
    validateAndContinue() {
      this.checkValidations();
      if (this.validForm) {
        this.$router.push({ name: 'Cart' })
      }
    },
    checkValidations() {
      this.forms.forEach(form => form.checkValidations());
    }
  },
  data: function() {
    return {
      saveData: true,
      saveContactData: false,
      forms: []
    }
  },
  mounted() {
    this.forms = Object.values(this.$refs).map((ref) => Array.isArray(ref) ? ref[0] : ref)
  },
  async created() {
    await this.loadExtrasPrices({
      extras: this.selectedProduct.extras.map((ext) => ext.id),
      date: this.selectedProduct.requirements.date ? this.details[0].date : null
    })
  }
};

</script>

<style scoped>

  .section-container {
    @apply w-full;
  }

  .main-section {
    @apply w-full;
  }

  .sub-section {
    @apply hidden;
  }

  @screen lg {
    .section-container {
      @apply flex
    }

    .main-section {
      @apply w-3/5 flex-grow;
    }

    .sub-section {
      @apply block w-2/5 ml-5 flex-grow-0 bg-white h-auto;
    }
  }

</style>
